import React, { useMemo, useState } from "react";
import EmployeeFormAdmin from "../../pages/Admin/EmployeeFormAdmin";
import { GlobalContext } from "../../Context/GlobalState";
import GlobalLoader from "../../components/GlobalLoader";

const EmployeeFormAdminWidget = ({ firmId, user }) => {
  const [transactionLoader, setTransactionLoaderState] = useState(false);

  const widgetUser = useMemo(
    () => ({
      us_type: "A",
      ...(user || {}),
      firm_id: user?.firm_id || user?.firmId || firmId,
    }),
    [firmId, user]
  );

  const contextValue = useMemo(
    () => ({
      Profileinfo: null,
      token: null,
      user: widgetUser,
      userparent: null,
      transactionLoader,
      accessData: null,
      accessDataemp: null,
      setTransactionLoaderState,
      setToken: () => {},
      setProfileinfo: () => {},
      setMyAccountInfo: () => {},
      setUserInfo: () => {},
      setUserParent: () => {},
      setAccessData: () => {},
      setAccessemployeData: () => {},
    }),
    [transactionLoader, widgetUser]
  );

  return (
    <GlobalContext.Provider value={contextValue}>
      <GlobalLoader />
      <EmployeeFormAdmin />
    </GlobalContext.Provider>
  );
};

export default EmployeeFormAdminWidget;
